import {Mesh} from './Mesh';
import {Selectable} from '../Selectable';
import {IScaleRelativeToCenter, IColorChangeable, ICloneable} from '../../Interfaces';
import {Scaler} from '../Scaler';

declare let THREE: any;

export class Rectangle extends Selectable implements IScaleRelativeToCenter, IColorChangeable, ICloneable {

  readonly scaler: Scaler;
  private _boundingBox;
  private color;
  private width: number;
  private height: number;
  // static readonly Name = "Rectangle";

  constructor() {
    super();
    this.add(new Mesh());
    this.scaler = new Scaler();
    this.add(this.scaler);
    this._boundingBox = new THREE.Box3();
    this.color = new THREE.Color(0x000000);
    // this.name = Rectangle.Name;
  }

  update(width: number, height: number) {
    this.width = width;
    this.height = height;
    const innerRectangle = this.getObjectByName(Mesh.Name);
    innerRectangle.scale.set(width, 1, height);
    this.selection.update();
    this.scaler.update();
  }

  updatePosition(offset) {
    const innerRectangle = this.getObjectByName(Mesh.Name);
    this.position.add(offset);
    innerRectangle.position.add(offset.negate());
  }

  getSize() {
    this._boundingBox.setFromObject(this.getObjectByName(Mesh.Name));
    const size = new THREE.Vector3();
    this._boundingBox.getSize(size);
    return size;
  }

  changeOrigin() {
    const innerRectangle = this.getObjectByName(Mesh.Name);
    innerRectangle.geometry.translate(0.5, 0, 0.5);
  }

  restoreOrigin() {
    const innerRectangle = this.getObjectByName(Mesh.Name);
    const offset = new THREE.Vector3(innerRectangle.scale.x / 2, 0, innerRectangle.scale.z / 2);
    this.position.add(offset);
    innerRectangle.geometry.translate(-0.5, 0, -0.5);
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName(Mesh.Name)];
  }

  setColor(color): void {
    this.color.copy(color);
    this.getObjectByName(Mesh.Name).setColor(color);
  }

  highlight() {
    super.highlight();
    this.scaler.update();
    this.scaler.visible = true;
  }

  unhighlight() {
    super.unhighlight();
    this.scaler.visible = false;
  }

  duplicate(): Rectangle {
    const rect = new Rectangle();
    rect.update(this.width, this.height);
    rect.setColor(this.color);
    return rect;
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    return {
      type: "Rectangle",
      position: pos,
      height: this.height,
      width: this.width,
      color: this.color.getHex()
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Rectangle/index.ts